import { MAX_DISPLAY_COMPUTER_NAME_LENGTH } from "@/define";

export function formatComputerName(computerName: string) {
  if (!computerName) return "";
  return `${computerName.substring(0, MAX_DISPLAY_COMPUTER_NAME_LENGTH)}${
    computerName.length > MAX_DISPLAY_COMPUTER_NAME_LENGTH ? "..." : ""
  }`;
}
